import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3f283d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "本フォームにてお申出いただくオンライン資料は、申出者が自ら出版したもの又は申出者が出版に責任を有しているものに限るようお願いいたします。"),
  /*#__PURE__*/_createElementVNode("p", null, "第三者からのお申出はお受けいたしません。お申出に当たりまして、下記についてご同意いただきますようお願いいたします。")
], -1))
const _hoisted_3 = { class: "area-button" }
const _hoisted_4 = { class: "list-button" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 同意しない（戻る） ")
const _hoisted_6 = { class: "list-button" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 同意する ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notes = _resolveComponent("Notes")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Notes),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_AppButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/dms/online'))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/online')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.toInput,
          onKeydown: _withKeys(_withModifiers(_ctx.toInput, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-toInput'
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ])
    ])
  ]))
}